import { motion } from "framer-motion";
import React from "react";

const certifications = [
    {
        title: "Q-SYS Training: Control & UCI Advanced",
        issuer: "QSC",
        year: "1/2026",

    },
    {
        title: "Q-SYS Control 101",
        issuer: "QSC",
        year: "12/2025",

    },
    {
        title: "Q-SYS Level 2",
        issuer: "QSC",
        year: "11/2025",

    },
    {
        title: "Dante Level 2 (2nd Edition)",
        issuer: "Audinate",
        year: "10/2024",

    },
    {
        title: "Dante Level 1 (2nd Edition)",
        issuer: "Audinate",
        year: "10/2024",

    },
    {
        title: "Q-SYS Level 1",
        issuer: "QSC",
        year: "05/2024",

    },
    {
        title: "Mikrotik Certified Network Associate (MTCNA)",
        issuer: "Mikrotik",
        year: "12/2022",

    },



];

const stackAreas = [
    {
        name: "Websites",
        copy: "Crafting responsive apps, websites, and dashboards that feel cohesive across screens.",
        tags: ["React", "Vue", "Framer Motion", "Tailwind", "Next.js"]
    },
    {
        name: "Control Systems",
        copy: "Designing Q-SYS control systems for enterprise applications such as schools, court rooms, and libraries.",
        tags: ["Q-SYS", "LUA", "Dante", "AV over IP", "Networking", "Troubleshooting"]
    },
    {
        name: "Video Games",
        copy: "Building playable worlds, multiplayer systems, and tooling on Roblox and experimental engines.",
        tags: ["Roblox Lua", "Roblox-TS", "Entity Component Systems", "Realtime Simulation", "Game Design"]
    },

];

const SkillsPage: React.FC = () => {
    return (
        <div className="bg-white text-slate-900 min-h-[100vh]">
            <div className="mx-auto flex max-w-6xl flex-col gap-16 px-4 py-16 sm:px-6 lg:px-8">
                <header className="space-y-3">
                    <p className="text-xs font-semibold uppercase text-slate-500">Credentials & craft</p>
                    <h1 className="text-4xl font-semibold sm:text-5xl">Skills + certifications</h1>
                    <p className="text-lg text-slate-500">
                        All of my certifications that help me build reliable, scalable, and maintainable systems across web, game, and AV domains.
                    </p>
                </header>

                <section className="space-y-6">
                    <div className="flex items-end justify-between">
                        <div>
                            <h2 className="text-3xl font-semibold text-slate-900">Certifications</h2>
                        </div>

                    </div>
                    <div className="grid gap-6 md:grid-cols-3">
                        {certifications.map((cert) => (
                            <motion.article key={cert.title}
                                className="rounded-3xl border border-slate-200 bg-white p-6 shadow-lg"
                                whileHover={{ scale: 1.02 }}
                                transition={{ type: "spring", stiffness: 120 }}>
                                <p className="text-xs font-semibold uppercase text-red-600">{cert.year}</p>
                                <h3 className="mt-3 text-xl font-semibold text-slate-900">{cert.title}</h3>
                                <p className="text-sm text-slate-500">{cert.issuer}</p>
                                {/* {cert.description && <p className="mt-2 text-sm text-slate-500">{cert.description}</p>} */}
                            </motion.article>
                        ))}
                    </div>
                </section>

                <section className="space-y-6">
                    <p className="text-xs font-semibold uppercase text-slate-500">Skills</p>
                    <h2 className="text-3xl font-semibold text-slate-900">Skills that I've picked up through a multitude of projects</h2>
                    <div className="grid gap-6 md:grid-cols-2">
                        {stackAreas.map((area) => (
                            <motion.article key={area.name}
                                className="rounded-3xl border border-slate-200 bg-white p-6 shadow-lg"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5 }}
                                whileHover={{ y: -6 }}>
                                <h3 className="text-xl font-semibold text-slate-900">{area.name}</h3>
                                <p className="mt-2 text-sm text-slate-500">{area.copy}</p>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {area.tags.map((tag) => (
                                        <span key={tag}
                                            className="rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-600">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </motion.article>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SkillsPage;
